import Quickview from './Quickview'

export default {
  Quickview
}



// WEBPACK FOOTER //
// ./src/app/configuration/ComcastSMBPremarket/theme/components/quickview/index.js